import { render, staticRenderFns } from "./ImageAdd.vue?vue&type=template&id=4968eb8b&scoped=true"
import script from "./ImageAdd.vue?vue&type=script&lang=js"
export * from "./ImageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4968eb8b",
  null
  
)

export default component.exports